import { render } from "./admin-view-log-workspace.vue?vue&type=template&id=eb65d0a4"
import script from "./admin-view-log-workspace.vue?vue&type=script&lang=js"
export * from "./admin-view-log-workspace.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/admin/admin-view-log-workspace.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eb65d0a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eb65d0a4', __exports__)) {
    api.reload('eb65d0a4', __exports__)
  }
  
  module.hot.accept("./admin-view-log-workspace.vue?vue&type=template&id=eb65d0a4", () => {
    api.rerender('eb65d0a4', render)
  })

}


export default __exports__